'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// PropTypes

// import moment from 'moment';

// import { setPathName } from 'redux/modules/setup';
// import { Promotion } from './../Home/';


// import exuWhite from 'assets/img/membership/exuWhite.png';

// import expiredVoucherImage from 'assets/img/voucher/expiredVoucherImage.jpg';

// import { localStore } from 'utils/localStorage';
// import { getPhone } from 'helpers/lib';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _components = require('components');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _defaultVoucherImage = require('assets/img/voucher/defaultVoucherImage.jpg');

var _defaultVoucherImage2 = _interopRequireDefault(_defaultVoucherImage);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _support = require('helpers/support');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    SERVICE_DETAIL: state.shops.SERVICE_DETAIL
  };
}, {
  loadServiceByHandle: shopActions.loadServiceByHandle,
  resetBooking: bookingActions.resetBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  changeService: bookingActions.changeService,
  showDownloadAppPopup: setupActions.showDownloadAppPopup
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceDetail, _Component);

  function ServiceDetail(props) {
    (0, _classCallCheck3.default)(this, ServiceDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceDetail.__proto__ || (0, _getPrototypeOf2.default)(ServiceDetail)).call(this, props));

    _this.state = {
      showErr: false,
      contentErr: {
        title: { text: 'Lỗi', type: 'error' },
        message: []
      },
      showFlow: false,
      contentFlow: {
        title: { text: 'Thông Báo', type: 'success' },
        message: []
      },
      showBranch: false,
      changeData: false
    };

    _this.toBooking = _this.toBooking.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ServiceDetail, [{
    key: 'moreDetail',
    value: function moreDetail(shopName) {
      _reactGa2.default.event({
        category: 'Shop',
        action: 'Clicked Shop Card from voucher',
        label: '' + shopName
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var handle = this.props.params.handle;

      console.log(this.props);
      if (handle) {
        this.props.loadServiceByHandle(handle);
      }
    }
  }, {
    key: 'toBooking',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.props.showDownloadAppPopup();
                // const {
                //   user,
                //   resetBooking,
                //   changeShopBeforeBooking,
                //   changeService,
                //   history,
                //   SERVICE_DETAIL: { data },
                // } = this.props;
                // let service = data;
                // const shop = service.shop;
                // // let service = _service;
                // // const shop = _shop;
                // console.log('toBooking', service, shop);
                // if (user) {
                //   resetBooking();
                //   await changeShopBeforeBooking(shop, user);
                //   service = {
                //     ...service,
                //     service: service._id,
                //     number: 1,
                //     name: service.name,
                //   };
                //   changeService(service);
                //   history.push(`/dat-lich`);
                //   ReactGA.event({
                //     category: 'Booking',
                //     action: 'Clicked To Step 1 (Shop Details)',
                //     label: `${shop.name}`,
                //   });
                // } else {
                //   resetBooking();
                //   await changeShopBeforeBooking(shop);
                //   service = {
                //     ...service,
                //     service: service._id,
                //     number: 1,
                //     name: service.name,
                //   };
                //   changeService(service);
                //   Helper.warn('trước khi vào đặt lịch');
                //   history.push(`/dat-lich`);
                //   ReactGA.event({
                //     category: 'Booking',
                //     action: 'Clicked Booking button (not logged in)',
                //     label: `${shop.name}`,
                //   });
                // }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toBooking() {
        return _ref.apply(this, arguments);
      }

      return toBooking;
    }()
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _this2 = this;

      var styles = require('./ServiceDetail.scss');
      var data = this.props.SERVICE_DETAIL.data;

      var service = data;
      var shop = service.shop;
      return _react2.default.createElement(
        'div',
        {
          id: 'serviceDetail',
          className: styles.serviceDetail,
          ref: 'serviceDetail'
        },
        _react2.default.createElement(
          'div',
          { className: styles.modalBody },
          _react2.default.createElement(
            'div',
            { className: styles.image },
            _react2.default.createElement('img', {
              src: service.image ? service.image : _defaultVoucherImage2.default,
              alt: 'H\xECnh avatar'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.primaryInfo },
            _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                service.name
              ),
              _react2.default.createElement(
                'div',
                { className: styles.rowInfo + ' ' + styles.shop },
                _react2.default.createElement('img', { src: _Images2.default.service.store, alt: '' }),
                shop.name,
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: '/' + shop.handle,
                    onClick: function onClick() {
                      return _this2.moreDetail(shop.name);
                    }
                  },
                  'Th\xF4ng tin shop'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.rowInfo },
                _react2.default.createElement('img', { src: _Images2.default.service.duration, alt: '' }),
                service.duration + ' ph\xFAt'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.rowInfo },
                _react2.default.createElement('img', { src: _Images2.default.service.money, alt: '' }),
                (0, _numeral2.default)(service.price).format('0,0') + ' đ'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.address },
                _react2.default.createElement('img', { src: _Images2.default.service.address, alt: '' }),
                shop.addressDisplay || shop.address
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.description },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle },
                ' M\xF4 t\u1EA3 d\u1ECBch v\u1EE5:'
              ),
              _react2.default.createElement('div', {
                className: styles.content,
                dangerouslySetInnerHTML: { __html: service.description || '' }
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.condition },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle },
                '\u0110i\u1EC1u ki\u1EC7n s\u1EED d\u1EE5ng'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.btnGroup },
            _react2.default.createElement(
              'div',
              {
                className: styles.btn + ' ' + styles.btnJoin + ' ' + styles.available + ' ' + styles.exchangeBtn,
                onClick: this.toBooking
              },
              '\u0110\u1EB6T L\u1ECACH'
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$SERVICE_DETAIL = this.props.SERVICE_DETAIL,
          loading = _props$SERVICE_DETAIL.loading,
          data = _props$SERVICE_DETAIL.data;
      var _state = this.state,
          showErr = _state.showErr,
          contentErr = _state.contentErr,
          showFlow = _state.showFlow,
          contentFlow = _state.contentFlow;

      return _react2.default.createElement(
        'div',
        { style: { display: 'block', width: '100%', height: '100%' } },
        !!(loading && !data) && _react2.default.createElement(_components.Loading, null),
        data && this.renderContent(),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_flow',
          show: showFlow,
          onHide: this.hideFlow,
          title: contentFlow.title,
          message: contentFlow.message,
          button: contentFlow.button,
          closeButton: true
        }),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_error',
          show: showErr,
          onHide: this.hideError,
          title: contentErr.title,
          message: contentErr.message,
          button: contentErr.button,
          closeButton: true
        })
      );
    }
  }]);
  return ServiceDetail;
}(_react.Component), _class2.propTypes = {
  SERVICE_DETAIL: _react.PropTypes.object,
  params: _react.PropTypes.object,
  history: _react.PropTypes.object,
  user: _react.PropTypes.object,
  // @action
  loadServiceByHandle: _react.PropTypes.func,
  resetBooking: _react.PropTypes.func,
  changeService: _react.PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = ServiceDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/ServiceDetail.js
// module id = 715
// module chunks = 0